import { ReactNode } from "react";
import PlacingSlipFilePreview, {
    formatFileSize,
    getFileExtension,
} from "./placing-slip-file-preview";

type Props = {
    file?: File | null;
    previewUrl?: string | null;
    previewLoading?: boolean;
    name: string;
    meta?: string;
    badge?: string;
    actions?: ReactNode;
};

const PlacingSlipPreviewCard = ({
    file,
    previewUrl,
    previewLoading = false,
    name,
    meta,
    badge,
    actions,
}: Props) => {
    const resolvedMeta =
        meta ||
        (file
            ? `${getFileExtension(file.name)} · ${formatFileSize(file.size)}`
            : badge || "PDF");

    return (
        <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="flex items-center gap-3 p-3">
                {previewLoading ? (
                    <div className="h-28 w-20 shrink-0 animate-pulse rounded-md border border-gray-200 bg-gray-100" />
                ) : (
                    <PlacingSlipFilePreview
                        file={file}
                        previewUrl={previewUrl}
                        title={name}
                    />
                )}
                <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-medium text-gray-900">
                        {name}
                    </p>
                    <p className="mt-0.5 text-xs text-gray-500">
                        {resolvedMeta}
                    </p>
                </div>
                {actions}
            </div>
        </div>
    );
};

export default PlacingSlipPreviewCard;
